var _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 111
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1h148a13 13 0 0113 13v83a13 13 0 01-13 13H14A13 13 0 011 97V14A13 13 0 0114 1z",
    fill: "none",
    stroke: "#5588ab",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle",
    d: "M16 7h145a9 9 0 019 9v80a9 9 0 01-9 9H16a9 9 0 01-9-9V16a9 9 0 019-9z",
    fill: "none",
    stroke: "#5588ab",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2",
    fill: "rgba(9,27,44,0.6)",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 15h24a3 3 0 013 3v24a3 3 0 01-3 3H18a3 3 0 01-3-3V18a3 3 0 013-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16c-1.103 0-2 .897-2 2v24c0 1.103.897 2 2 2h24c1.103 0 2-.897 2-2V18c0-1.103-.897-2-2-2H18m0-1h24a3 3 0 013 3v24a3 3 0 01-3 3H18a3 3 0 01-3-3V18a3 3 0 013-3z",
    fill: "rgba(255,255,255,0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#5588ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 79A2.25 2.25 0 1121 81.25 2.25 2.25 0 0123.25 79z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Oval",
    d: "M30.25 79A2.25 2.25 0 1128 81.25 2.25 2.25 0 0130.25 79zM37.25 79A2.25 2.25 0 1135 81.25 2.25 2.25 0 0137.25 79zM44.25 79A2.25 2.25 0 1142 81.25 2.25 2.25 0 0144.25 79zM55.25 79A2.25 2.25 0 1153 81.25 2.25 2.25 0 0155.25 79zM62.25 79A2.25 2.25 0 1160 81.25 2.25 2.25 0 0162.25 79zM69.25 79A2.25 2.25 0 1167 81.25 2.25 2.25 0 0169.25 79zM76.25 79A2.25 2.25 0 1174 81.25 2.25 2.25 0 0176.25 79zM87.25 79A2.25 2.25 0 1185 81.25 2.25 2.25 0 0187.25 79zM94.25 79A2.25 2.25 0 1192 81.25 2.25 2.25 0 0194.25 79zM101.25 79A2.25 2.25 0 1199 81.25a2.25 2.25 0 012.25-2.25zM108.25 79a2.25 2.25 0 11-2.25 2.25 2.25 2.25 0 012.25-2.25zM119.25 79a2.25 2.25 0 11-2.25 2.25 2.25 2.25 0 012.25-2.25zM126.25 79a2.25 2.25 0 11-2.25 2.25 2.25 2.25 0 012.25-2.25zM133.25 79a2.25 2.25 0 11-2.25 2.25 2.25 2.25 0 012.25-2.25zM140.25 79a2.25 2.25 0 11-2.25 2.25 2.25 2.25 0 012.25-2.25z"
  }))));
}
export default SvgIcCard;